import { useEffect, useCallback, useRef } from 'react';
import Axios from 'axios';

const useTrackBounceRate = () => {
  const isBounced = useRef(true); // Use useRef to persist the value across renders

  // Function to handle user interaction (i.e., if they navigate to another page)
  const handleInteraction = useCallback(() => {
    isBounced.current = false; // The user interacted, so it's not a bounce
  }, []); // The callback stays the same throughout renders

  // Add event listeners for page interactions (e.g., clicking a link)
  useEffect(() => {
    window.addEventListener('click', handleInteraction); // User clicks anywhere on the page

    return () => {
      window.removeEventListener('click', handleInteraction); // Cleanup listener on unmount
    };
  }, [handleInteraction]); // handleInteraction is stable

  // Log the bounce rate when the user leaves the page
  const handleExit = useCallback(() => {
    const bounceStatus = isBounced.current ? 'bounce' : 'no-bounce';

    // Send bounce data to backend for logging
    Axios.post('/api/logBounceRate', { bounceStatus })
      .then(response => {
        console.log('Bounce status logged successfully');
      })
      .catch(error => {
        console.error('Error logging bounce status:', error);
      });
  }, []);  // handleExit doesn't depend on anything

  // Add event listener for page unload (when the user leaves the page)
  useEffect(() => {
    window.addEventListener('beforeunload', handleExit); // Trigger on page unload

    return () => {
      window.removeEventListener('beforeunload', handleExit);
    };
  }, [handleExit]); // handleExit is stable

};

export default useTrackBounceRate;
